(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["variant-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var button = event.target.closest('.kcg-pack-option');
    if (!button) return;
    var qty = parseInt(button.getAttribute('data-qty'), 10);
    if (isNaN(qty)) return;
    var container = button.closest('.kcg-pack-picker__options');
    if (container) {
      container.querySelectorAll('.kcg-pack-option').forEach(function (o) {
        o.classList.remove('kcg-pack-option--active');
      });
    }
    button.classList.add('kcg-pack-option--active');
    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    if (form) {
      var qtyInput = form.querySelector('input[name="quantity"]');
      if (!qtyInput) {
        qtyInput = document.createElement('input');
        qtyInput.type = 'hidden';
        qtyInput.name = 'quantity';
        qtyInput.value = '1';
        form.appendChild(qtyInput);
      }
      qtyInput.value = String(qty);
    }
    var productForm = document.querySelector('product-form-component');
    if (productForm) {
      productForm.dataset.quantityDefault = String(qty);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
